import Alpine from 'alpinejs'
import intersect from '@alpinejs/intersect'
import laboratoriesSearch from '../_stores/laboratoriesSearch'

Alpine.plugin(intersect)

// Register stores
Alpine.store('laboratoriesSearch', laboratoriesSearch())

Alpine.start()
